import React, { useState, useEffect } from 'react';
import { 
  Search, Book, Star, BookOpen, Library, 
  MessageSquare, Check, ArrowLeft,
  Users, LogOut, Loader2, Globe, User
} from 'lucide-react';

// Firebase Imports
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import { 
  getFirestore, 
  collection, 
  doc, 
  setDoc, 
  onSnapshot, 
  query,
  where,
  serverTimestamp
} from "firebase/firestore";

// --- GÜNCELLENMİŞ STİLLER (STANDART CSS) ---
const customStyles = `
  .kitap-dunyasi-wrapper {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #f8fafc;
    min-height: 100vh;
    color: #1e293b;
    line-height: 1.5;
  }
  
  .kitap-dunyasi-wrapper * {
    box-sizing: border-box;
  }

  /* Navbar */
  .kd-navbar {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid #e2e8f0;
    position: sticky;
    top: 0;
    z-index: 50;
    padding: 0 1rem;
    height: 70px;
    display: flex;
    align-items: center;
  }
  .kd-nav-content {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .kd-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    font-size: 1.25rem;
    color: #4f46e5;
    cursor: pointer;
  }
  .kd-nav-links {
    display: flex;
    gap: 20px;
  }
  .kd-nav-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 0.95rem;
    color: #64748b;
    font-weight: 500;
    transition: color 0.2s;
  }
  .kd-nav-btn:hover, .kd-nav-btn.active {
    color: #4f46e5;
  }

  /* Layout */
  .kd-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  .kd-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 20px;
  }

  /* Kartlar */
  .kd-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    border: 1px solid #e2e8f0;
    transition: transform 0.2s, box-shadow 0.2s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }
  .kd-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  }
  .kd-card-img {
    aspect-ratio: 2/3;
    width: 100%;
    object-fit: cover;
    background: #f1f5f9;
  }
  .kd-card-body {
    padding: 12px;
  }
  .kd-title {
    font-weight: 700;
    font-size: 1rem;
    margin: 0 0 4px 0;
    color: #1e293b;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .kd-author {
    font-size: 0.85rem;
    color: #64748b;
    margin: 0;
  }

  /* Form Elemanları */
  .kd-input {
    width: 100%;
    padding: 12px 20px;
    border-radius: 99px;
    border: 2px solid #e2e8f0;
    font-size: 1rem;
    outline: none;
    transition: border-color 0.2s;
  }
  .kd-input:focus {
    border-color: #4f46e5;
  }
  .kd-btn-primary {
    background: #4f46e5;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: background 0.2s;
  }
  .kd-btn-primary:hover {
    background: #4338ca;
  }
  .kd-btn-success {
    background: #10b981;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: default;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  
  /* Google Button Style */
  .kd-btn-google {
    background: white;
    color: #1f2937;
    border: 1px solid #e2e8f0;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s;
    width: 100%;
  }
  .kd-btn-google:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  .kd-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 20px 0;
    color: #94a3b8;
    font-size: 0.8rem;
  }
  .kd-divider::before, .kd-divider::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e2e8f0;
  }
  .kd-divider span {
    padding: 0 10px;
  }

  .kd-btn-circle {
    position: absolute;
    right: 8px;
    top: 6px;
    background: #4f46e5;
    color: white;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Detay Sayfası */
  .kd-hero {
    height: 250px;
    background: #0f172a;
    position: relative;
    overflow: hidden;
  }
  .kd-hero img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
    filter: blur(10px);
  }
  .kd-back-btn {
    position: absolute;
    top: 20px;
    left: 20px;
    background: rgba(255,255,255,0.2);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    backdrop-filter: blur(5px);
  }
  .kd-detail-content {
    max-width: 1100px;
    margin: -100px auto 0;
    padding: 0 20px;
    position: relative;
    z-index: 10;
    display: flex;
    gap: 40px;
  }
  .kd-cover-wrapper {
    flex-shrink: 0;
    width: 220px;
  }
  .kd-book-cover {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3);
    border: 4px solid white;
  }
  .kd-action-card {
    background: white;
    padding: 15px;
    border-radius: 12px;
    margin-top: 15px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }
  .kd-action-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    margin-bottom: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    color: #475569;
    cursor: pointer;
    font-size: 0.9rem;
  }
  .kd-action-btn:hover {
    background: #f8fafc;
  }
  .kd-action-btn.active {
    background: #eef2ff;
    border-color: #6366f1;
    color: #4338ca;
  }
  
  /* Auth Sayfası */
  .kd-auth-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 20px;
  }
  .kd-auth-box {
    background: white;
    padding: 40px;
    border-radius: 16px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 400px;
  }

  /* PROFIL STİLLERİ */
  .kd-profile-container {
    max-width: 800px;
    margin: 40px auto;
    padding: 0 20px;
  }
  .kd-profile-header {
    background: white;
    border-radius: 16px;
    padding: 30px;
    text-align: center;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
  }
  .kd-avatar-large {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #9333ea);
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    border: 4px solid white;
    box-shadow: 0 0 0 2px #e2e8f0;
    object-fit: cover;
  }
  .kd-stat-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 20px;
  }
  .kd-stat-box {
    background: white;
    padding: 25px 20px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    text-align: center;
    transition: transform 0.2s;
  }
  .kd-stat-box:hover {
    transform: translateY(-5px);
    border-color: #4f46e5;
  }
  .kd-stat-number {
    font-size: 2rem;
    font-weight: 800;
    color: #1e293b;
    line-height: 1;
    margin-bottom: 5px;
  }
  .kd-stat-label {
    color: #64748b;
    font-size: 0.9rem;
    font-weight: 500;
  }

  /* MOBILE NAV (YENİ EKLENDİ) */
  .kd-mobile-nav {
    display: none; /* Desktop'ta gizli */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #e2e8f0;
    padding: 10px;
    justify-content: space-around;
    z-index: 100;
    padding-bottom: env(safe-area-inset-bottom);
    box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
  }
  .kd-mobile-nav-btn {
    background: none;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #94a3b8;
    font-size: 0.7rem;
    cursor: pointer;
    padding: 5px;
    gap: 4px;
  }
  .kd-mobile-nav-btn.active {
    color: #4f46e5;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .kd-detail-content {
      flex-direction: column;
      align-items: center;
      margin-top: -60px;
    }
    .kd-cover-wrapper {
      width: 160px;
      margin-bottom: 20px;
    }
    .kd-nav-links {
      display: none; /* Navbar linklerini gizle */
    }
    .kd-mobile-nav {
      display: flex; /* Mobilde göster */
    }
    .kd-container {
      padding-bottom: 80px; /* Alt menü için boşluk */
    }
  }
`;

// --- Firebase Initialization ---

const firebaseConfig = {
  apiKey: "AIzaSyBHHzwdTziGznbWOaXhq3G-zhk_WixGcEU",
  authDomain: "bin1kitap.firebaseapp.com",
  projectId: "bin1kitap",
  storageBucket: "bin1kitap.firebasestorage.app",
  messagingSenderId: "505989523258",
  appId: "1:505989523258:web:0ba3ed4537940db19e1203"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const appId = 'bin1kitap'; 

// --- Helper Components ---

const StarRating = ({ rating, setRating, readOnly = false, size = 18 }) => {
  return (
    <div style={{ display: 'flex', gap: '2px' }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          onClick={(e) => {
            e.stopPropagation();
            !readOnly && setRating && setRating(star);
          }}
          disabled={readOnly}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: readOnly ? 'default' : 'pointer',
            color: star <= rating ? '#facc15' : '#e2e8f0',
            transform: readOnly ? 'none' : 'scale(1)',
            transition: 'transform 0.1s'
          }}
        >
          <Star 
            size={size} 
            fill={star <= rating ? "currentColor" : "none"}
            stroke="currentColor"
          />
        </button>
      ))}
    </div>
  );
};

// --- Sayfa Bileşenleri ---

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAuth = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
      }
    } catch (err) {
      console.error(err);
      let msg = "Bir hata oluştu.";
      if (err.code === 'auth/invalid-email') msg = "Geçersiz e-posta adresi.";
      if (err.code === 'auth/user-not-found') msg = "Kullanıcı bulunamadı.";
      if (err.code === 'auth/wrong-password') msg = "Hatalı şifre.";
      if (err.code === 'auth/email-already-in-use') msg = "Bu e-posta zaten kullanımda.";
      if (err.code === 'auth/weak-password') msg = "Şifre en az 6 karakter olmalı.";
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    setError('');
    try {
      console.log("Google Login başlatılıyor...");
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (err) {
      console.error("Google Login Error:", err);
      let errorMsg = "Google ile giriş hatası: " + err.message;
      
      if (err.code === 'auth/popup-closed-by-user') {
        errorMsg = "Pencere kapatıldı, giriş yapılamadı.";
      } else if (err.code === 'auth/popup-blocked') {
        errorMsg = "Tarayıcı açılır pencereyi (popup) engelledi. Lütfen adres çubuğundan izin verin.";
      } else if (err.code === 'auth/operation-not-allowed') {
        errorMsg = "Google girişi aktif değil! Firebase Konsol > Authentication > Sign-in method sekmesinden Google'ı etkinleştirin.";
      } else if (err.code === 'auth/unauthorized-domain') {
        // DÜZELTME: Kullanıcıya tam olarak hangi domaini eklemesi gerektiğini gösteriyoruz.
        errorMsg = `Bu alan adı (${window.location.hostname}) yetkisiz. Lütfen Firebase Konsol > Authentication > Settings > Authorized domains kısmına bu adresi ekleyin.`;
      }
      
      setError(errorMsg);
      alert(errorMsg); // Kullanıcıya anında bildirim ver
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="kitap-dunyasi-wrapper kd-auth-wrapper">
      <div className="kd-auth-box">
        <div style={{textAlign: 'center', marginBottom: '30px'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '8px', color: '#4f46e5', fontWeight: 'bold', fontSize: '1.5rem'}}>
            <BookOpen size={28} />
            Bin Bir Kitap
          </div>
          <p style={{color: '#64748b', marginTop: '10px'}}>{isLogin ? 'Hoş Geldiniz' : 'Hesap Oluşturun'}</p>
        </div>

        <form onSubmit={handleAuth} style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
          <input
            type="email"
            required
            className="kd-input"
            style={{borderRadius: '8px'}}
            placeholder="E-posta adresi"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            required
            className="kd-input"
            style={{borderRadius: '8px'}}
            placeholder="Şifre"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error && <p style={{color: '#ef4444', fontSize: '0.9rem', margin: 0, padding: '10px', background: '#fef2f2', borderRadius: '6px'}}>{error}</p>}
          <button type="submit" className="kd-btn-primary" style={{width: '100%'}}>
            {isLoading ? <Loader2 className="animate-spin" /> : (isLogin ? 'Giriş Yap' : 'Kayıt Ol')}
          </button>
        </form>

        <div className="kd-divider">
          <span>VEYA</span>
        </div>

        <button 
          type="button" // ÖNEMLİ: Form submit'i tetiklemesin diye type="button" eklendi
          onClick={handleGoogleLogin} 
          className="kd-btn-google" 
          disabled={isLoading}
        >
          <Globe size={18} />
          Google ile Giriş Yap
        </button>

        <div style={{textAlign: 'center', marginTop: '20px'}}>
          <button
            onClick={() => setIsLogin(!isLogin)}
            style={{background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontWeight: '500'}}
          >
            {isLogin ? "Hesabın yok mu? Kaydol" : "Hesabın var mı? Giriş Yap"}
          </button>
        </div>
      </div>
    </div>
  );
};

const BookDetailPage = ({ book, user, myBookData, onBack, onUpdateStatus, onUpdateReview }) => {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [quoteText, setQuoteText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  useEffect(() => {
    if (myBookData) {
      setRating(myBookData.rating || 0);
      setReviewText(myBookData.review || '');
      setQuoteText(myBookData.quote || '');
    } else {
      // Veri yoksa temizle (kitap değiştiğinde önemli)
      setRating(0);
      setReviewText('');
      setQuoteText('');
    }
  }, [myBookData, book.id]); 

  // Kullanıcı bir şey yazdığında "Kaydedildi" yazısını kaldır
  useEffect(() => {
    setIsSaved(false);
  }, [rating, reviewText, quoteText]);

  useEffect(() => {
    const q = query(
      collection(db, 'artifacts', appId, 'public', 'data', 'reviews'),
      where('bookId', '==', book.id)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const docs = snapshot.docs.map(d => ({id: d.id, ...d.data()}));
      docs.sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));
      setReviews(docs);
    });
    return () => unsubscribe();
  }, [book.id]);

  const handleSaveReview = async () => {
    if(!user) return;
    setIsSubmitting(true);
    setIsSaved(false); // Önce sıfırla
    
    const reviewId = `${user.uid}_${book.id}`;
    const publicReviewData = {
      bookId: book.id,
      userId: user.uid,
      userName: user.email ? user.email.split('@')[0] : (user.displayName || 'Anonim'),
      rating: rating,
      review: reviewText,
      quote: quoteText,
      timestamp: serverTimestamp()
    };
    
    const privateReviewData = {
      rating: rating, 
      review: reviewText, 
      quote: quoteText,
      id: book.id,
      title: book.title,
      author: book.author,
      coverUrl: book.coverUrl,
      year: book.year || '',
      lastUpdated: new Date().toISOString()
    };

    try {
      await setDoc(doc(db, 'artifacts', appId, 'public', 'data', 'reviews', reviewId), publicReviewData);
      // Await ekleyerek işlemin tamamlanmasını bekliyoruz
      await onUpdateReview(privateReviewData);
      
      setIsSaved(true); // Başarılı, Kaydedildi göster
      
      // 3 saniye sonra eski haline döndür
      setTimeout(() => setIsSaved(false), 3000);
      
    } catch (e) {
      console.error("Yorum kaydetme hatası:", e);
      alert("Yorum kaydedilirken bir hata oluştu: " + e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const status = myBookData?.status || 'none';

  return (
    <div className="kitap-dunyasi-wrapper">
      <div className="kd-hero">
        <img src={book.coverUrl} alt="bg" />
        <button onClick={onBack} className="kd-back-btn">
          <ArrowLeft size={16} /> Geri Dön
        </button>
      </div>

      <div className="kd-detail-content">
        <div className="kd-cover-wrapper">
          <img src={book.coverUrl} className="kd-book-cover" alt={book.title} />
          
          <div className="kd-action-card">
            <h4 style={{fontSize: '0.8rem', fontWeight: 'bold', textTransform: 'uppercase', color: '#94a3b8', marginBottom: '10px'}}>Durum</h4>
             {[
               { id: 'reading', label: 'Okuyorum', icon: BookOpen },
               { id: 'completed', label: 'Okudum', icon: Check },
               { id: 'wantToRead', label: 'Okuyacağım', icon: Library }
             ].map((item) => (
               <button 
                  key={item.id}
                  onClick={() => onUpdateStatus(item.id)}
                  className={`kd-action-btn ${status === item.id ? 'active' : ''}`}
                >
                  <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <item.icon size={16}/> {item.label}
                  </span>
                  {status === item.id && <Check size={16} />}
               </button>
             ))}
          </div>
        </div>

        <div style={{flex: 1, paddingTop: '30px'}}>
          <h1 style={{fontSize: '2rem', fontWeight: '800', lineHeight: 1.2, marginBottom: '5px'}}>{book.title}</h1>
          <p style={{color: '#64748b', fontSize: '1.1rem'}}>{book.author} <span style={{opacity: 0.6}}>• {book.year}</span></p>

          <div style={{display: 'flex', gap: '20px', margin: '20px 0'}}>
             <div style={{background: 'white', padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '10px'}}>
                <Star size={20} color="#facc15" fill="#facc15"/>
                <span style={{fontWeight: 'bold', fontSize: '1.2rem'}}>{reviews.length > 0 ? (reviews.reduce((a,b)=>a+(b.rating||0),0)/reviews.filter(r=>r.rating>0).length).toFixed(1) : '-'}</span>
             </div>
             <div style={{background: 'white', padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '10px'}}>
                <Users size={20} color="#6366f1"/>
                <span style={{fontWeight: 'bold', fontSize: '1.2rem'}}>{reviews.length}</span>
                <span style={{fontSize: '0.8rem', color: '#64748b'}}>Okur</span>
             </div>
          </div>

          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px'}}>
            <div style={{background: 'white', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0'}}>
              <h3 style={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px'}}>
                <MessageSquare size={18} color="#4f46e5"/> Görüşlerin
              </h3>
              
              <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                <div>
                  <label style={{display: 'block', fontSize: '0.75rem', fontWeight: 'bold', color: '#94a3b8', marginBottom: '5px'}}>PUANIN</label>
                  <StarRating rating={rating} setRating={setRating} size={24} />
                </div>
                <div>
                  <label style={{display: 'block', fontSize: '0.75rem', fontWeight: 'bold', color: '#94a3b8', marginBottom: '5px'}}>İNCELEME</label>
                  <textarea 
                    className="kd-input" 
                    style={{borderRadius: '8px', minHeight: '80px'}}
                    placeholder="Bu kitap hakkında ne düşünüyorsun?"
                    value={reviewText}
                    onChange={(e)=>setReviewText(e.target.value)}
                  />
                </div>
                <div>
                  <label style={{display: 'block', fontSize: '0.75rem', fontWeight: 'bold', color: '#94a3b8', marginBottom: '5px'}}>ALINTI</label>
                  <input 
                    className="kd-input" 
                    style={{borderRadius: '8px'}}
                    placeholder="Unutulmaz bir cümle..."
                    value={quoteText}
                    onChange={(e)=>setQuoteText(e.target.value)}
                  />
                </div>
                <button 
                  onClick={handleSaveReview} 
                  disabled={isSubmitting} 
                  className={isSaved ? "kd-btn-success" : "kd-btn-primary"} // Stil değişimi
                  style={{width: '100%', transition: 'all 0.3s'}}
                >
                  {isSubmitting ? (
                    <> <Loader2 className="animate-spin" size={18}/> Kaydediliyor... </>
                  ) : isSaved ? (
                    <> <Check size={18}/> Kaydedildi </>
                  ) : (
                    'Paylaş'
                  )}
                </button>
              </div>
            </div>

            <div>
              <h3 style={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '15px'}}>Son Değerlendirmeler</h3>
              <div className="custom-scrollbar" style={{maxHeight: '400px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '15px'}}>
                {reviews.length === 0 && <p style={{color: '#94a3b8', fontStyle: 'italic'}}>Henüz değerlendirme yok.</p>}
                {reviews.map(rev => (
                  <div key={rev.id} style={{background: 'white', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
                       <span style={{fontWeight: 'bold', fontSize: '0.9rem', color: '#334155'}}>{rev.userName}</span>
                       {rev.rating > 0 && <StarRating rating={rev.rating} readOnly size={12}/>}
                    </div>
                    {rev.review && <p style={{fontSize: '0.9rem', color: '#475569', margin: '0 0 8px 0'}}>{rev.review}</p>}
                    {rev.quote && (
                      <div style={{borderLeft: '3px solid #6366f1', paddingLeft: '10px', marginTop: '8px'}}>
                        <p style={{fontStyle: 'italic', fontSize: '0.9rem', color: '#334155', margin: 0}}>"{rev.quote}"</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- Ana Sayfa ---

export default function KitapDunyasi() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('explore'); 
  const [queryText, setQueryText] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [library, setLibrary] = useState({});
  const [selectedBook, setSelectedBook] = useState(null);
  const [activeTab, setActiveTab] = useState('reading');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!user?.uid) { // UID kontrolü
      setLibrary({}); 
      return; 
    }
    
    const q = collection(db, 'artifacts', appId, 'users', user.uid, 'books');
    const unsub = onSnapshot(q, (snap) => {
      const data = {};
      snap.forEach(d => data[d.id] = d.data());
      setLibrary(data);
    }, (error) => {
      console.error("Kütüphane veri çekme hatası:", error);
    });
    
    return () => unsub();
  }, [user?.uid]); 

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!queryText.trim()) return;
    setIsSearching(true);
    setView('explore');
    try {
      const res = await fetch(`https://openlibrary.org/search.json?q=${encodeURIComponent(queryText)}&limit=20&fields=key,title,author_name,cover_i,first_publish_year`);
      const data = await res.json();
      setResults(data.docs.map(doc => ({
        id: doc.key.replace('/works/', ''),
        title: doc.title,
        author: doc.author_name ? doc.author_name[0] : 'Bilinmiyor',
        year: doc.first_publish_year,
        coverUrl: doc.cover_i ? `https://covers.openlibrary.org/b/id/${doc.cover_i}-L.jpg` : 'https://via.placeholder.com/150x220?text=Kitap'
      })));
    } catch (e) { console.error(e); } 
    finally { setIsSearching(false); }
  };

  const updateStatus = async (status) => {
    if(!user || !selectedBook) return;
    const bookId = selectedBook.id;
    
    const existingData = library[bookId] || {};
    
    const newData = {
      ...existingData,
      id: bookId,
      title: selectedBook.title, 
      author: selectedBook.author,
      coverUrl: selectedBook.coverUrl,
      year: selectedBook.year || '',
      status: status,
      lastUpdated: new Date().toISOString()
    };
    
    try {
      await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'books', bookId), newData, {merge: true});
    } catch(e) {
      console.error("Durum güncellenemedi:", e);
    }
  };

  const updateReview = async (data) => {
    if(!user || !selectedBook) return;
    try {
      // Await kullanarak işlemin bitmesini bekliyoruz
      await setDoc(doc(db, 'artifacts', appId, 'users', user.uid, 'books', selectedBook.id), data, {merge: true});
    } catch (e) {
      console.error("Private inceleme güncellenemedi:", e);
      throw e; // Hatayı yukarı fırlat ki handleSaveReview yakalayabilsin
    }
  };

  if (loading) return <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Loader2 className="animate-spin"/></div>;
  if (!user) return <>
    <style>{customStyles}</style>
    <AuthPage />
  </>;
  
  if (view === 'detail' && selectedBook) {
    return <>
      <style>{customStyles}</style>
      <BookDetailPage 
        book={selectedBook} 
        user={user} 
        myBookData={library[selectedBook.id]} 
        onBack={() => setView('explore')}
        onUpdateStatus={updateStatus}
        onUpdateReview={updateReview}
      />
    </>;
  }

  const filteredLibrary = Object.values(library).filter(b => b.status === activeTab);

  // İstatistik Hesaplamaları
  const stats = {
    total: Object.keys(library).length,
    completed: Object.values(library).filter(b => b.status === 'completed').length,
    reading: Object.values(library).filter(b => b.status === 'reading').length,
    wantToRead: Object.values(library).filter(b => b.status === 'wantToRead').length,
    reviews: Object.values(library).filter(b => b.review).length
  };

  return (
    <div className="kitap-dunyasi-wrapper">
      <style>{customStyles}</style>
      
      <nav className="kd-navbar">
        <div className="kd-nav-content">
          <div className="kd-brand" onClick={() => setView('explore')}>
             <div style={{background: '#4f46e5', color: 'white', padding: '6px', borderRadius: '6px', display: 'flex'}}><BookOpen size={20}/></div>
             Bin Bir Kitap
          </div>
          <div className="kd-nav-links">
            <button className={`kd-nav-btn ${view === 'explore' ? 'active' : ''}`} onClick={() => setView('explore')}>Keşfet</button>
            <button className={`kd-nav-btn ${view === 'library' ? 'active' : ''}`} onClick={() => setView('library')}>Kütüphanem</button>
            <button className={`kd-nav-btn ${view === 'profile' ? 'active' : ''}`} onClick={() => setView('profile')}>Profil</button>
            <button className="kd-nav-btn" onClick={() => signOut(auth)} title="Çıkış Yap"><LogOut size={18}/></button>
          </div>
        </div>
      </nav>

      <div className="kd-container">
        
        {view === 'explore' && (
          <div>
             <div style={{textAlign: 'center', margin: '40px 0'}}>
                <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '20px', background: 'linear-gradient(to right, #4f46e5, #9333ea)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>Yeni Hikayeler Keşfet</h1>
                <form onSubmit={handleSearch} style={{maxWidth: '600px', margin: '0 auto', position: 'relative'}}>
                   <input 
                      className="kd-input" 
                      placeholder="Kitap adı, yazar veya ISBN..."
                      value={queryText}
                      onChange={(e) => setQueryText(e.target.value)}
                   />
                   <button type="submit" className="kd-btn-circle" disabled={isSearching}>
                      {isSearching ? <Loader2 size={20} className="animate-spin"/> : <Search size={20}/>}
                   </button>
                </form>
             </div>

             <div className="kd-grid">
               {results.map(book => (
                 <div key={book.id} className="kd-card" onClick={() => { setSelectedBook(book); setView('detail'); }}>
                   <div style={{position: 'relative'}}>
                     <img src={book.coverUrl} className="kd-card-img" alt={book.title}/>
                     {library[book.id]?.status && (
                       <div style={{position: 'absolute', top: '10px', right: '10px', background: '#4f46e5', width: '10px', height: '10px', borderRadius: '50%', border: '2px solid white'}}></div>
                     )}
                   </div>
                   <div className="kd-card-body">
                     <h3 className="kd-title">{book.title}</h3>
                     <p className="kd-author">{book.author}</p>
                   </div>
                 </div>
               ))}
             </div>
             
             {results.length === 0 && !isSearching && (
               <div style={{textAlign: 'center', color: '#94a3b8', marginTop: '60px'}}>
                 <Book size={64} style={{opacity: 0.2, margin: '0 auto 20px'}}/>
                 <p>Arama yaparak kitapları listeyebilirsiniz.</p>
               </div>
             )}
          </div>
        )}

        {view === 'library' && (
          <div>
            <div style={{display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '20px', borderBottom: '1px solid #e2e8f0', marginBottom: '30px'}}>
               {[
                 {id: 'reading', label: 'Okuyorum', icon: BookOpen},
                 {id: 'wantToRead', label: 'Okuyacaklarım', icon: Library},
                 {id: 'completed', label: 'Bitirdiklerim', icon: Check}
               ].map(tab => (
                 <button 
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    style={{
                      background: activeTab === tab.id ? '#4f46e5' : 'white',
                      color: activeTab === tab.id ? 'white' : '#64748b',
                      border: activeTab === tab.id ? 'none' : '1px solid #e2e8f0',
                      padding: '8px 16px',
                      borderRadius: '20px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      whiteSpace: 'nowrap',
                      fontWeight: '500'
                    }}
                 >
                    <tab.icon size={16}/> {tab.label} ({Object.values(library).filter(b=>b.status===tab.id).length})
                 </button>
               ))}
            </div>

            <div className="kd-grid">
               {filteredLibrary.map(book => (
                 <div key={book.id} className="kd-card" onClick={() => { setSelectedBook(book); setView('detail'); }}>
                   <div style={{position: 'relative'}}>
                     <img src={book.coverUrl} className="kd-card-img" alt={book.title}/>
                   </div>
                   <div className="kd-card-body">
                     <h3 className="kd-title">{book.title}</h3>
                     <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                        <p className="kd-author">{book.year}</p>
                        {book.rating > 0 && <div style={{display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.8rem', color: '#eab308', fontWeight: 'bold'}}><Star size={12} fill="currentColor"/> {book.rating}</div>}
                     </div>
                   </div>
                 </div>
               ))}
            </div>
            {filteredLibrary.length === 0 && (
               <div style={{textAlign: 'center', padding: '60px 0', color: '#94a3b8'}}>
                  Bu listede henüz kitap yok.
               </div>
            )}
          </div>
        )}

        {view === 'profile' && (
          <div className="kd-profile-container">
            <div className="kd-profile-header">
              {user.photoURL ? (
                <img src={user.photoURL} alt="Avatar" className="kd-avatar-large" />
              ) : (
                <div className="kd-avatar-large">
                  {user.email ? user.email.charAt(0).toUpperCase() : 'U'}
                </div>
              )}
              <h2 style={{fontSize: '1.5rem', fontWeight: '800', color: '#1e293b', marginBottom: '5px'}}>
                {user.displayName || 'Kitap Sever'}
              </h2>
              <p style={{color: '#64748b', marginBottom: '5px'}}>{user.email}</p>
              <p style={{fontSize: '0.8rem', color: '#94a3b8'}}>
                Üyelik Tarihi: {new Date(user.metadata.creationTime).toLocaleDateString('tr-TR')}
              </p>
            </div>

            <h3 style={{fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '20px', color: '#334155'}}>Kütüphane İstatistikleri</h3>
            <div className="kd-stat-grid">
              <div className="kd-stat-box">
                <div className="kd-stat-number" style={{color: '#4f46e5'}}>{stats.total}</div>
                <div className="kd-stat-label">Toplam Kitap</div>
              </div>
              <div className="kd-stat-box">
                <div className="kd-stat-number" style={{color: '#10b981'}}>{stats.completed}</div>
                <div className="kd-stat-label">Bitirilen</div>
              </div>
              <div className="kd-stat-box">
                <div className="kd-stat-number" style={{color: '#3b82f6'}}>{stats.reading}</div>
                <div className="kd-stat-label">Okunan</div>
              </div>
              <div className="kd-stat-box">
                <div className="kd-stat-number" style={{color: '#8b5cf6'}}>{stats.wantToRead}</div>
                <div className="kd-stat-label">Okunacak</div>
              </div>
              <div className="kd-stat-box">
                <div className="kd-stat-number" style={{color: '#f59e0b'}}>{stats.reviews}</div>
                <div className="kd-stat-label">İnceleme</div>
              </div>
            </div>

            <button 
              onClick={() => signOut(auth)} 
              className="kd-btn-primary" 
              style={{background: '#ef4444', width: '100%', marginTop: '40px', padding: '15px'}}
            >
              <LogOut size={20}/> Oturumu Kapat
            </button>
          </div>
        )}

        {/* Mobile Bottom Navigation */}
        <div className="kd-mobile-nav">
          <button 
            onClick={() => setView('explore')}
            className={`kd-mobile-nav-btn ${view === 'explore' ? 'active' : ''}`}
          >
            <Search size={24} />
            <span>Keşfet</span>
          </button>
          <button 
            onClick={() => setView('library')}
            className={`kd-mobile-nav-btn ${view === 'library' ? 'active' : ''}`}
          >
            <Library size={24} />
            <span>Kütüphanem</span>
          </button>
          <button 
            onClick={() => setView('profile')}
            className={`kd-mobile-nav-btn ${view === 'profile' ? 'active' : ''}`}
          >
            <User size={24} />
            <span>Profil</span>
          </button>
        </div>

      </div>
    </div>
  );
}